module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAC8vsC8vsC8vsC8vsD/6Lb/6LbdLkTdLkTdLkTdLkRVrO70q7r///9YWVtYWVv/zE07iMP/6Lb/zE3/6Lb/zE3/zE0pxW30AAAAF3RSTlMAUN//AP8AUN//AP////8A///f31BQAGRT1AwAAACxSURBVHja7dXLCsIwFIThXNQkxluv7/+ohqIo1ToneKBQ5t9kU75Fm6HGWOdhzu5QxnpRFkJOBjkIeWEQ2gs7gFaCQkxfi+FYBYW0WJigDHpCcRmKVVD6UTV0Kp1L7ych1ZeNP7/ahVxjIq8upWtpOh/pQhlESAah/54KVLJakNOCvPhC3kBbhzIIPUOIELfGrRHi1rg1QluFmlmfUDOLUBXU6kCd6XWgwYx9+z/UDeMdYH/DOWWokyUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3ec.png
// module id = 820
// module chunks = 0